import { render, staticRenderFns } from "./Subject.vue?vue&type=template&id=7d96235e&scoped=true&"
import script from "./Subject.vue?vue&type=script&lang=js&"
export * from "./Subject.vue?vue&type=script&lang=js&"
import style0 from "./Subject.vue?vue&type=style&index=0&id=7d96235e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d96235e",
  null
  
)

export default component.exports